<template>
  <div
    v-show="reference !== null && reference.length > 0 && isVisible"
    class="scf-search-box-suggestions"
  >
    <WjTreeView
      v-show="suggestions.length > 0"
      :items-source="groupedSuggestions"
      :checkOnClick="true"
      displayMemberPath="header"
      childItemsPath="items"
      :initialized="initTreeView"
      :itemClicked="goToSearchPage"
      :formatItem="formatItem"
    >
    </WjTreeView>
    <span v-show="suggestions.length == 0">
      {{ suggestionsPlaceholder }}
    </span>
  </div>
</template>

<script>
import { defineComponent, computed } from "vue";
import { WjTreeView } from "@grapecity/wijmo.vue2.nav";

import ErrorsHelper from "@/_helpers/ErrorsHelper";

export default defineComponent({
  setup() {},
  components: {
    WjTreeView,
  },
  props: {
    reference: {
      type: String,
    },
    suggestions: {
      type: Array,
      default: () => [],
    },
    isVisible: {
      type: Boolean,
      default: () => true,
    },
    isLoading: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      wjTreeViewControl: null,
      groupedSuggestions: null,
      groupingHeaders: [],
    };
  },
  watch: {
    suggestions(newVal) {
      this.groupedSuggestions = this.groupSuggestions(
        newVal,
        this.groupingHeaders
      );
    },
  },
  computed: {
    suggestionsPlaceholder() {
      if (this.isLoading) return this.$t("search.searchInProgress");
      if (
        this.suggestions.length == 0 &&
        this.reference !== null &&
        this.reference.length > 0
      )
        if (this.reference.length > 3) return this.$t("search.noResults");
        else return this.$t("search.searchRefTip");
      return null;
    },
  },
  methods: {
    initTreeView: function (ctl) {
      this.wjTreeViewControl = ctl;
    },
    goToSearchPage: function (t) {
      if (!t || !t.selectedItem || !t.selectedItem["routeName"]) return;
      this.getRoute(t.selectedItem);
    },
    getRoute(selectedItem) {
      const routeParameters = selectedItem.routeParameters;
      const route = this.resolveRoute(selectedItem.routeName);
      if (route !== null) {
        const computedPath = this.generatePathWithParams(
          route.path,
          routeParameters
        );
        window.open(computedPath, "_blank");
      } else {
        ErrorsHelper.UnknownRouteFromSearchResult(selectedItem.routeName);
      }
    },
    resolveRoute(routeName) {
      for (let route of this.$router.getRoutes()) {
        if (route.name === routeName) return route;
      }
      return null;
    },
    generatePathWithParams(path, parameters) {
      let modifiedPath = path;
      Object.keys(parameters).forEach((param) => {
        let value = parameters[param].includes("/")
          ? encodeURIComponent(parameters[param])
          : parameters[param];
        const placeholder = `:${param}`;
        const optionalPlaceholder = `:${param}?`;

        // Replace placeholder with the actual value
        modifiedPath = modifiedPath
          .replace(optionalPlaceholder, value)
          .replace(placeholder, value);
      });
      return modifiedPath;
    },
    formatItem(s, e) {
      const reference = this.$props.reference.toUpperCase();
      if (e.dataItem.header.startsWith(reference)) {
        e.element.firstChild.innerHTML = e.dataItem.header.replace(
          reference,
          `<b>${reference}</b>`
        );
      }
    },
    groupSuggestions(arr, keys) {
      return arr.reduce((acc, obj) => {
        let currentLevel = acc;
        keys.forEach((key, index) => {
          const value = obj[key];
          const isLastKey = index === keys.length - 1;

          if (!currentLevel.find((item) => item.header === value)) {
            const newItem = { header: value, items: [] };
            currentLevel.push(newItem);
            currentLevel = newItem.items;
          } else {
            currentLevel = currentLevel.find(
              (item) => item.header === value
            ).items;
          }

          if (isLastKey) {
            // Replace 'items' array with the content of 'pages'
            currentLevel.length = 0; // Clear existing 'items' array
            obj.pages.forEach((page) => {
              page["header"] = computed(() =>
                this.$t(`searchPagesResults.${page.routeName}`)
              );
              currentLevel.push(page);
            });
          }
        });

        return acc;
      }, []);
    },
  },
  created() {
    let groups = [];
    // Option if you want to group also by module : if (user is admin) groups.push("module")
    if (
      this.$jwt.scope &&
      this.$jwt.scope.length >= 1 &&
      (this.$jwt.scope.length > 1 || this.$jwt.scope[0] == "ALL")
    )
      groups.push("clientIdentifier");
    groups.push("foundReference");
    this.groupingHeaders = groups;
  },
});
</script>

<style scoped>
.scf-search-box-suggestions {
  font-family: D-DIN !important;
  padding: 6px;
  text-align: left;
  position: relative;
  border-radius: 0 0 5px 5px;
  background-color: white;
  color: black;
  z-index: 2;
  box-shadow: 0px 0px 1px 0px;
}
.scf-search-box-suggestion:hover {
  background-color: #80adbf;
}
</style>
